import { useState } from "react";
import { browserCanGoBack } from "@/utils/browserCanGoBack";

export function BrowserBackLink({ className }: { className?: string }) {
  const [canGoBack] = useState(browserCanGoBack);

  if (!canGoBack) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => window.history.back()}
      className={className}
    >
      ← Back
    </button>
  );
}
